import React, { useState } from 'react';
import './FAQ.css'

const FAQ = () => {
    const faqData = [
        {
            "section": "Account and Registration",
            "questions": [
                {
                    "question": "How do I create an account?",
                    "answer": "Download the app, click on \"Sign Up,\" and follow the instructions to provide your basic details, such as name, email, and phone number."
                },
                {
                    "question": "What documents or details are required for registration?",
                    "answer": "Typically, you’ll need your name, date of birth, gender, and contact information. Some apps may also ask for identity verification documents like Aadhaar or a valid ID."
                },
                {
                    "question": "Can I register on behalf of someone else?",
                    "answer": "Yes, you can register on behalf of a family member or friend, but ensure you provide accurate details and have their consent."
                },
                {
                    "question": "How do I verify my profile?",
                    "answer": "Verification is usually done by submitting ID proof or verifying your phone number or email address through OTP."
                },
                {
                    "question": "Can I sign up using my social media or email?",
                    "answer": "Yes, most matrimony apps allow you to sign up using your Google account, Facebook, or email."
                }
            ]
        },
        {
            "section": "Profile Management",
            "questions": [
                {
                    "question": "How do I complete or edit my profile?",
                    "answer": "Go to the \"Profile\" section in the app, click \"Edit,\" and update your personal details, photos, and preferences."
                },
                {
                    "question": "Can I upload multiple photos to my profile?",
                    "answer": "Yes, most apps allow you to upload multiple photos. Make sure they meet the app’s guidelines."
                },
                {
                    "question": "How do I make my profile more visible?",
                    "answer": "Fill out all sections of your profile, upload a clear profile picture, and verify your profile to increase visibility."
                },
                {
                    "question": "Can I hide certain details from other users?",
                    "answer": "Yes, privacy settings usually allow you to hide details like phone numbers, email, or specific personal information."
                },
                {
                    "question": "How do I deactivate or delete my profile?",
                    "answer": "Go to the settings menu, find the \"Account\" section, and select \"Deactivate\" or \"Delete Profile.\" Follow the instructions provided."
                }
            ]
        },
        {
            "section": "Search and Matches",
            "questions": [
                {
                    "question": "How does the matching algorithm work?",
                    "answer": "The app uses your preferences, such as age, location, education, and community, to suggest compatible matches."
                },
                {
                    "question": "Can I filter profiles by location, community, or profession?",
                    "answer": "Yes, use the search or filter options to narrow down profiles based on your criteria."
                },
                {
                    "question": "How do I save or favorite a profile?",
                    "answer": "Click on the heart or bookmark icon on the profile to save it to your favorites list."
                },
                {
                    "question": "Can I block or report a user?",
                    "answer": "Yes, go to the user’s profile, click on the \"More\" or \"Options\" menu, and select \"Block\" or \"Report.\""
                },
                {
                    "question": "What does “recommended match” mean?",
                    "answer": "These are profiles suggested by the app based on your preferences and interests."
                }
            ]
        },
        {
            "section": "Communication",
            "questions": [
                {
                    "question": "How do I send or receive messages?",
                    "answer": "Open a profile you’re interested in and click on \"Send Message\" to start a conversation. Some apps may require mutual interest or premium membership to message."
                },
                {
                    "question": "Are messages private?",
                    "answer": "Yes, all communication is typically private and visible only to the involved users."
                },
                {
                    "question": "Can I video call other users?",
                    "answer": "Some apps offer a secure video calling feature, but both users may need to agree to the call."
                },
                {
                    "question": "Can I view who visited my profile?",
                    "answer": "Yes, many apps provide a feature to see who viewed your profile, often as part of a premium subscription."
                },
                {
                    "question": "What happens if someone doesn’t respond to my message?",
                    "answer": "It’s up to the user to respond. If they’re uninterested, the app encourages you to explore other matches."
                }
            ]
        },
        {
            "section": "Subscription and Payments",
            "questions": [
                {
                    "question": "Is the app free to use?",
                    "answer": "The app usually offers free basic features but may require a subscription for advanced features like messaging or viewing contact details."
                },
                {
                    "question": "How do I subscribe to a premium plan?",
                    "answer": "Go to the \"Subscription\" section, choose a plan, and proceed to payment."
                },
                {
                    "question": "What payment methods are accepted?",
                    "answer": "Most apps accept credit/debit cards, net banking, and digital wallets like PayPal or Google Pay."
                },
                {
                    "question": "Can I get a refund if I’m not satisfied?",
                    "answer": "Refund policies vary by app. Check the terms and conditions for details on refunds or cancellations."
                },
                {
                    "question": "Are payments secure?",
                    "answer": "Yes, most apps use secure payment gateways to protect your transaction details."
                }
            ]
        },
        {
            "section": "Technical Support",
            "questions": [
                {
                    "question": "What should I do if the app isn’t working?",
                    "answer": "Try restarting the app, updating it to the latest version, or contacting customer support."
                },
                {
                    "question": "How do I contact customer support?",
                    "answer": "Use the \"Help\" or \"Support\" section in the app to reach out via email, chat, or phone."
                },
                {
                    "question": "Can I recover my account if I forget my password?",
                    "answer": "Yes, click on \"Forgot Password\" on the login page and follow the steps to reset it."
                },
                {
                    "question": "What if I see inappropriate content?",
                    "answer": "Report the content using the \"Report\" option available in the app."
                },
                {
                    "question": "How do I update the app to the latest version?",
                    "answer": "Go to your device’s app store, search for the app, and click \"Update\" if an update is available."
                }
            ]
        }
    ];
    

    const [openIndex, setOpenIndex] = useState(null);

    const handleToggle = (index) => {
        setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    return (
        <div className="faq-container">
            <div className='faq-content'>
                <h1 className="faq-section-title">Frequently Asked Questions</h1>
                <p className="faq-section-description">Find answers to common questions below:</p>
                {faqData.map((section, sectionIndex) => (
                    <div key={sectionIndex} className="faq-section">
                        <h2 className="faq-section-header">{section.section}</h2>
                        {section.questions.map((faq, faqIndex) => {
                            const questionIndex = `${sectionIndex}-${faqIndex}`;
                            return (
                                <div key={questionIndex} className={`faq-item ${openIndex === questionIndex ? 'open' : ''}`}>
                                    <div className="faq-header" onClick={() => handleToggle(questionIndex)}>
                                        <h4>{faq.question}</h4>
                                        {openIndex === questionIndex ? (
                                            <i className="fas fa-chevron-up"></i>
                                        ) : (
                                            <i className="fas fa-chevron-down"></i>
                                        )}
                                    </div>
                                    {openIndex === questionIndex && (
                                        <div className="faq-answer">
                                            <p>{faq.answer}</p>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
    
};

export default FAQ;
